import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)

const router = new Router({
  base: '/',
  // mode: 'history',
  routes: [
    {
      path: '/', component: () => import('@/layout/home/Index'), name: '', redirect: '/life',
      children: [
        { path: 'news', component: () => import('@/views/News'), name: 'HomeNews' },
        { path: 'life', component: () => import('@/views/Life'), name: 'HomeLife' },
        { path: 'yellow-page', component: () => import('@/views/YellowPage/Index'), name: 'HomeYellowPage' },
        { path: 'exchange-rate', component: () => import('@/views/ExchangeRate'), name: 'HomeExchangeRage' }
      ]
    },
    {
      path: '/yellow-page', component: () => import('@/layout/default/Index'), name: 'YpIndex',
      children: [
        { path: 'search', component: () => import('@/views/YellowPage/Search'), name: 'YpSearch' },
        { path: 'industry/:id', component: () => import('@/views/YellowPage/Industry'), name: 'YpIndustry' },
        { path: 'shop/:id', component: () => import('@/views/YellowPage/Shop'), name: 'YpShop' }
      ]
    },
    {
      path: '/bangdai', component: () => import('@/layout/default/Index'), name: '',
      children: [
        { path: '', component: () => import('@/views/Bangdai/Index'), name: 'BangdaiIndex' },
        { path: 'push', component: () => import('@/views/Bangdai/Push'), name: 'BangdaiPush' },
        { path: ':id', component: () => import('@/views/Bangdai/Detail'), name: 'BangdaiDetail' }
      ]
    },
    { path: '*', component: () => import('@/layout/404') }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = '葡萄牙宝马街'
  NProgress.start()
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js